import React, { useState } from 'react';
import { Edit2, Link } from 'react-feather';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumbs, { Crumb } from 'components/ui/Breadcrumbs';
import { routes as ROUTES } from 'constants/config';
import request from 'utils/request_ajax';
import { Spinner } from 'ui';
import { togglePreview } from '../../actions/journeyBuilder';
import * as actions from '../../actions/journeyBuilder';

const Topbar = () => {
  const { title, updatedAt, published, description, id } = useSelector(
    state => state,
  );
  const { previewing } = useSelector(state => state.ui);

  const [loading, setLoading] = useState(false);

  const { journeyId } = useParams();

  const dispatch = useDispatch();

  const handlePublish = () => {
    setLoading(true);
    request
      .patchJSON(ROUTES.JOURNEY.PUBLISH_JOURNEY(journeyId))
      .then(() => {
        dispatch(
          actions.updateJourneyDetails({
            title,
            description,
            updatedAt,
            published: true,
          }),
        );
        setLoading(false);
      })
      .fail(() => {
        // TODO: error handling
      });
  };

  const [showLinkCopied, updateShowLinkCopied] = useState(false);

  const topbarClassName = classNames('JourneyBuilderTopbar', {
    'JourneyBuilderTopbar-editing': !previewing,
  });

  return (
    <div className={topbarClassName}>
      {previewing ? (
        <>
          <Breadcrumbs
            parentUrl="/content"
            parentTitle={t('journeys.builder.content')}
            className="mr-24 mt-1 mb-1"
          >
            <Crumb>{title}</Crumb>
          </Breadcrumbs>
          <div className="JourneyBuilderTopbar-actionButtons">
            {published ? (
              <button
                type="button"
                className="JourneyBuilderTopbar-share"
                onClick={() => {
                  navigator.clipboard.writeText(
                    `https://${window.location.hostname}/journey/${id}`,
                  );
                  updateShowLinkCopied(true);

                  setTimeout(() => {
                    updateShowLinkCopied(false);
                  }, 2000);
                }}
              >
                <>
                  {/* eslint-disable-next-line */}
                  <Link size={16} />
                  {showLinkCopied
                    ? t('journeys.builder.link_copied')
                    : t('journeys.builder.share_link')}
                </>
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="JourneyBuilderTopbar-save"
                  onClick={() => dispatch(togglePreview())}
                >
                  <Edit2 className="JourneyBuilderTopbar-icon--alt" size={16} />
                  {t('journeys.builder.edit')}
                </button>
                <button
                  type="button"
                  className="JourneyBuilderTopbar-publish"
                  onClick={handlePublish}
                >
                  {loading ? (
                    <div className="JourneyBuilderTopbar-publishing">
                      <Spinner />
                      <div className="JourneyBuilderTopbar-spinner">
                        {t('journeys.builder.publishing')}
                      </div>
                    </div>
                  ) : (
                    <div>{t('journeys.builder.publish')}</div>
                  )}
                </button>
              </>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="JourneyBuilderTopbar-title">
            <h1>{t('journeys.builder.title')}</h1>
          </div>
          <div className="JourneyBuilderTopbar-actionButtons">
            <div className="JourneyBuilderTopbar-autosaveTimestamp">
              {updatedAt && `${t('journeys.builder.autosaved')} ${updatedAt}`}
            </div>
            <button
              type="button"
              children={t('journeys.builder.finish_editing')}
              className="JourneyBuilderTopbar-finishEditing"
              onClick={() => dispatch(togglePreview())}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Topbar;
